import CraftBuyInMarketplaceBtn from "components/crafting/CraftBuyInMarketplaceBtn";
import QuickCraftButton from "components/quick-craft/QuickCraftButton";

const CraftIdentityMatchesDetails = ({ item, isReadyToCraft }) => {
  return (
    <ul className="card-details__craft-sublist">
      <li className="card-details__craft-sublist-item-owned">
        <p>
          <span className="card-details__craft-sublist-item-value">
            Identities owned
          </span>
          <span className="card-details__craft-sublist-item-status">
            {item.identity_owned}
          </span>
        </p>
        {isReadyToCraft && <QuickCraftButton id={item.id} name={item.name} />}
      </li>

      <li className="card-details__craft-sublist-wrapper">
        <p className="card-details__craft-sublist-item">
          <span className="card-details__craft-sublist-item-value">
            {item.birth_month.name}
          </span>
          <span className="card-details__craft-sublist-item-status">
            {item.birth_month.status}
          </span>
          <CraftBuyInMarketplaceBtn
            status={item.birth_month.status}
            id={item.birth_month.marketplace_id}
            name={item.birth_month.name}
            type={"month"}
          />
        </p>
        <p className="card-details__craft-sublist-item">
          <span className="card-details__craft-sublist-item-value">
            {item.birth_day.name}
          </span>
          <span className="card-details__craft-sublist-item-status">
            {item.birth_day.status}
          </span>
          <CraftBuyInMarketplaceBtn
            status={item.birth_day.status}
            id={item.birth_day.marketplace_id}
            name={item.birth_day.name}
            type={"day"}
          />
        </p>
        <p className="card-details__craft-sublist-item">
          <span className="card-details__craft-sublist-item-value">
            {item.birth_year.name}
          </span>
          <span className="card-details__craft-sublist-item-status">
            {item.birth_year.status}
          </span>
          <CraftBuyInMarketplaceBtn
            status={item.birth_year.status}
            id={item.birth_year.marketplace_id}
            name={item.birth_year.name}
            type={"year"}
          />
        </p>
        <p className="card-details__craft-sublist-item">
          <span className="card-details__craft-sublist-item-value">
            {item.category.name}
          </span>
          <span className="card-details__craft-sublist-item-status">
            {item.category.status}
          </span>
          <CraftBuyInMarketplaceBtn
            status={item.category.status}
            id={item.category.marketplace_id}
            name={item.category.name}
            type={"category"}
          />
        </p>
      </li>
    </ul>
  );
};

export default CraftIdentityMatchesDetails;
